import React from 'react';

const Settings = () => {
  return (
    <div>
      <h1>Settings Page</h1>
      <p>This is the settings page.</p>
    </div>
  );
};

export default Settings;
